import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import Header from './Header'
import Footer from './Footer'

function processInitialQueue() {
  if (window.shgn === undefined) {
    // it shouldn't be possible to get here, but BOY are we gonna have problems if we do...
    return
  }

  // No need to process the queue if its undefined.
  if (window.shgn.q === undefined) {
    return
  }

  // No need to process the queue if it doesn't have any items in it.
  if (window.shgn.q.length === 0) {
    return
  }

  const next = window.shgn.q[0]

  enqueue(next[0], next[1])
}

function enqueue(action, payload) {
  if (action === 'init') {
    initialize(payload)
  }
}

enqueue.hintBalanceChanged = () => {
  const e = new StorageEvent('storage', {
    key: 'shgn::balance-expires',
    newValue: null,
  })
  window.dispatchEvent(e)
}

function initialize(config) {
  if (document.getElementById('universal-header')) {
    ReactDOM.render(<Header config={config} />, document.getElementById('universal-header'))
  } else {
    // eslint-disable-next-line no-console
    console.error('An element with an id of universal-header could not be found at the time this script ran')
  }
  if (document.getElementById('universal-footer')) {
    ReactDOM.render(<Footer config={config} />, document.getElementById('universal-footer'))
  } else {
    // eslint-disable-next-line no-console
    console.error('An element with an id of universal-footer could not be found at the time this script ran')
  }
}

processInitialQueue()

window.shgn = enqueue



// WEBPACK FOOTER //
// ./src/index.js